import type { CarouselitemsUnion } from '@seek/cmsu-cms-connect';

export type CarouselItem = Omit<CarouselitemsUnion, 'id' | 'stage'>;

export interface ItemWithKey {
  item: CarouselItem;
  key: string;
}

export type CarouselChunk = ItemWithKey[];

// Constants
export const CAROUSEL_CONSTANTS = {
  ANIMATION_DURATION: 300,
  DEFAULT_MAX_ITEMS: 3,
  MOBILE_ITEM_WIDTH: '280px',
  DESCENDER_PADDING: '4px',
} as const;

// Animation directions
export type AnimationDirection = 'left' | 'right';

// Create chunks of items
export const createChunks = (
  items: CarouselItem[],
  chunkSize: number,
): CarouselChunk[] => {
  const itemsWithKeys = items.map((item, index) => ({
    item,
    key: `item-${index}`,
  }));

  const chunks: CarouselChunk[] = [];
  for (let i = 0; i < itemsWithKeys.length; i += chunkSize) {
    chunks.push(itemsWithKeys.slice(i, i + chunkSize));
  }

  return chunks;
};

// Calculate total chunks needed
export const calculateTotalChunks = (
  itemCount: number,
  chunkSize: number,
): number => Math.ceil(itemCount / chunkSize);

// Check if chunk is first or last
export const getChunkPosition = (
  currentIndex: number,
  totalChunks: number,
) => ({
  isFirst: currentIndex === 0,
  isLast: currentIndex === totalChunks - 1,
});
